import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=2d0ac8ba&"
import script from "./Completion.vue?vue&type=script&lang=js&"
export * from "./Completion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports